import { render, staticRenderFns } from "./spin.vue?vue&type=template&id=f4ac7d10&scoped=true"
import script from "./spin.vue?vue&type=script&lang=js"
export * from "./spin.vue?vue&type=script&lang=js"
import style0 from "./spin.vue?vue&type=style&index=0&id=f4ac7d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ac7d10",
  null
  
)

export default component.exports